/* Little Cubbie — Cubbie Playtime guide: FAQ search + open a linked question. */
(() => {
  const init = () => {
    const search = document.querySelector('.lc-setup-guide #guide-search');
    if (search && !search.dataset.ready) {
      search.dataset.ready = '1';
      const root = search.closest('.lc-setup-guide');
      const groups = [...root.querySelectorAll('.faq-group')];
      const status = root.querySelector('.search-status');
      search.addEventListener('input', () => {
        const term = search.value.trim().toLowerCase();
        let count = 0;
        groups.forEach(group => {
          let matches = 0;
          group.querySelectorAll('details').forEach(item => {
            const show = !term || item.textContent.toLowerCase().includes(term);
            item.hidden = !show;
            if (show) { matches++; count++; }
            item.open = Boolean(term && show);
          });
          group.hidden = matches === 0;
        });
        status.hidden = !term;
        status.textContent = count ? `${count} answer${count === 1 ? '' : 's'} found.` : 'No answers found. Try another word, or email our team below.';
      });
    }
    openTarget();
  };
  function openTarget() {
    const hash = location.hash;
    if (!hash) return;
    let target;
    try { target = document.querySelector(hash); } catch (e) { return; }
    if (target && target.tagName === 'DETAILS') {
      const search = document.querySelector('.lc-setup-guide #guide-search');
      if (search && search.value) { search.value = ''; search.dispatchEvent(new Event('input')); }
      target.open = true;
      target.scrollIntoView({ block: 'start' });
    }
  }
  window.addEventListener('hashchange', openTarget);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
